export const API_BASE_URL =
  import.meta.env.VITE_BACKEND_API_URL || "http://localhost:8000/api/";
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

export const Rating = {
  Again: 1,
  Hard: 2,
  Good: 3,
  Easy: 4,
};

// TASK_STATUS and SNIPPET_TYPE map to backend choice fields, so they live in
// apiEnums.ts where they're statically checked against the generated OpenAPI
// types (a hand-edit that drifts from the backend fails `npm run typecheck`).
export { SNIPPET_TYPE, TASK_STATUS } from "./apiEnums";

// The snippet language allowlist is NOT a constant here — it's a serializer-
// level allowlist on a free CharField (not a model `choices` enum), so it
// can't be a generated type. The frontend fetches it at runtime from
// GET /api/snippets/languages/ (see hooks/useSnippetLanguages) so there's no
// hand-copied mirror to drift from snippets.models.LANGUAGE_ALLOWLIST.
